import React, { useState, useRef } from 'react';
import { Layout, ChevronRight } from 'react-feather';
import Button from '@/components/styled/Button';
import { ColorPopOver } from '@/components/popover/ColorPopOver';
import { useHoverIntent } from '@/hooks/useHoverIntent';

interface ColorMenuItemProps {
    onSetBackgroundColor: (color: string) => void;
    zIndex: number;
    label: string;
}

export function ColorMenuItem({ onSetBackgroundColor, zIndex, label }: ColorMenuItemProps) {
    const [isColorPickerOpen, setIsColorPickerOpen] = useState(false);
    const colorButtonRef = useRef<HTMLButtonElement>(null);
    const [selectedColor, setSelectedColor] = useState<string>('blank');

    const { handleMouseEnter, handleMouseLeave, clearHoverTimeout } = useHoverIntent(
        isColorPickerOpen,
        setIsColorPickerOpen,
        300,
    );

    return (
        <>
            <div className="border-t dark:border-saga-gray-700 my-1" />
            <Button.Plain
                ref={colorButtonRef}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                onClick={() => setIsColorPickerOpen(!isColorPickerOpen)}
            >
                <Button.BasePadding>
                    <span className="flex text-sm items-center justify-between w-full">
                        <span className="flex items-center">
                            <Layout className="stroke-gray-dark mr-2 my-auto" size={14} />
                            <span>{label}</span>
                        </span>
                        <ChevronRight className="stroke-gray-dark ml-auto" size={14} />
                    </span>
                </Button.BasePadding>
            </Button.Plain>
            <ColorPopOver
                attachToRef={colorButtonRef}
                isOpen={isColorPickerOpen}
                selectedColors={{ background: selectedColor, text: 'blank' }}
                setIsOpen={setIsColorPickerOpen}
                onCreate={(value, type) => {
                    if (type === 'bg') {
                        setSelectedColor(value);
                        onSetBackgroundColor(value);
                    }
                }}
                zIndex={zIndex}
                showBackgroundOnly={true}
                position="right"
                onMouseEnter={clearHoverTimeout}
                onMouseLeave={handleMouseLeave}
            />
        </>
    );
}
